import braintreeSetup from './braintreeSetup';
import checkoutBraintree from './checkoutBraintree';
import checkout2C2P from './checkout2C2P';
import checkoutNeweb from './checkoutNeweb';
import checkoutOffline from './checkoutOffline';
import checkoutLinePay from './checkoutLinePay';
import deliveryInfo from './deliveryInfo';
import paymentReceipt from './paymentReceipt';
import changePlan from './changePlan';

export default {
  braintreeSetup,
  checkoutBraintree,
  checkout2C2P,
  checkoutNeweb,
  checkoutOffline,
  checkoutLinePay,
  deliveryInfo,
  paymentReceipt,
  changePlan,
};



// WEBPACK FOOTER //
// ./app/redux/purchase/index.js